import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Analytics from "@/components/Analytics";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Courses from "@/pages/Courses";
import PianoCourse from "@/pages/PianoCourse";
import CourseDetail from "@/pages/CourseDetail";
import Store from "@/pages/Store";
import Gallery from "@/pages/Gallery";
import Contact from "@/pages/Contact";
import ThankYou from "@/pages/ThankYou";
import LocationPage from "@/pages/LocationPage";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import "@/App.css";

function App() {
    return (
        <HelmetProvider>
            <div className="App">
                <Analytics />
                <BrowserRouter>
                    <Routes>
                        <Route element={<Layout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/courses" element={<Courses />} />
                            <Route path="/courses/piano" element={<PianoCourse />} />
                            <Route path="/courses/:slug" element={<CourseDetail />} />
                            <Route path="/locations/:slug" element={<LocationPage />} />
                            <Route path="/shop" element={<Store />} />
                            <Route path="/gallery" element={<Gallery />} />
                            <Route path="/blog" element={<Blog />} />
                            <Route path="/blog/:slug" element={<BlogPost />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/thank-you" element={<ThankYou />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
                <Toaster theme="dark" position="top-center" richColors />
            </div>
        </HelmetProvider>
    );
}

export default App;
